import { spevalApi } from 'yxt-biz-pc/packages/api';

spevalApi.defaults.headers['x-yxt-product'] = 'sp';

// 保存评估方案详情
export const postEvalInfo = (data) => {
  return spevalApi.post('/mgr/evaluations', data);
};

// 获取评估方案详情
export const getEvalInfo = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluations/${evaluationId}`);
};
